module.exports = __webpack_public_path__ + "static/img/8.af18573.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/sp/8.png
// module id = 7tqG
// module chunks = 0